export interface SearchOrderListRequest {
  selectionDateStart: string
  selectionDateEnd: string
  selectionCount: number | null
  selectionType: string
  status: string
  displayMemo: string
}

export function SearchOrderListRequestToJSON(
  value: SearchOrderListRequest
): any {
  return {
    selection_date_start:
      value.selectionDateStart !== '' ? value.selectionDateStart : undefined,
    selection_date_end:
      value.selectionDateEnd !== '' ? value.selectionDateEnd : undefined,
    selection_count:
      value.selectionCount !== null ? value.selectionCount : undefined,
    selection_type:
      value.selectionType !== '' ? value.selectionType : undefined,
    status: value.status !== '' ? value.status : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined
  }
}
